const list = {
  header: [
    {
      id: 'name.en',
      label: 'Name',
      orderBy: 'name.en',
      align: 'left',
    },
    {
      id: 'publish',
      label: 'Publish',
      align: 'left',
      switch: true,
    },
  ],
  permission: 'list',
  actions: ['bulk remove', 'delete', 'update'],
};
const create = {
  fields: [
    {
      type: 'mixed',
      name: 'name',
      label: 'Name',
      required: true,
      elements: [
        {
          type: 'text',
          name: 'en',
          label: 'English',
        },
        {
          type: 'text',
          name: 'ar',
          label: 'Arabic',
        },
      ],
    },
  ],
};
const edit = {
  fields: [
    {
      type: 'mixed',
      name: 'name',
      label: 'Name',
      required: true,
      elements: [
        {
          type: 'text',
          name: 'en',
          label: 'English',
        },
        {
          type: 'text',
          name: 'ar',
          label: 'Arabic',
        },
      ],
    },
  ],
};

const order = {
  fields: [
    {
      id: 'name',
      label: 'Name',
      child: 'en',
      align: 'left',
    },
  ],
  permission: 'order',
};

const search = {
  fields: [
    {
      type: 'text',
      name: 'name',
    },
  ],
};

const data = { list, create, edit, order, search };

export default data;
